import React, { PureComponent } from 'react';
import { createBrowserHistory } from 'history';
import ReactHintFactory from 'react-hint';
import * as Sentry from '@sentry/react';
import { Integrations } from '@sentry/tracing';

import './app.scss';

import AppRouter from './router';

import { login, logout } from 'api/auth';
import { getCurrentUser } from 'helpers/session';
import { UserContext } from 'contexts/user';

const history = createBrowserHistory();
const ReactHint = ReactHintFactory(React);

process.env.NODE_ENV === 'production' &&
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_KEY,
    integrations: [new Integrations.BrowserTracing()],

    tracesSampleRate: 1.0,
  });

class App extends PureComponent {
  state = {
    loading: true,
    user: null,
    errors: null,
  };

  async componentDidMount() {
    const user = await getCurrentUser();

    this.setState({ user, loading: false });
  }

  onSignIn = async ({ data, redirectTo }) => {
    this.setState({ loading: true });

    const { error } = await login({ ...data });

    if (error) return this.setState({ errors: [error], loading: false });

    const user = await getCurrentUser();

    this.setState({ user, loading: false });

    if (redirectTo) {
      return history.push(redirectTo);
    }

    history.push('/');
  };

  onSignOut = async () => {
    await logout();
    this.setState({ user: null, errors: null });
  };

  setUser = (user) => this.setState({ user });

  render() {
    const { user, errors, loading } = this.state;

    if (loading) return null;

    return (
      <>
        <React.StrictMode>
          <ReactHint
            autoPosition
            events
            delay={{ show: 50, hide: 50 }}
            onRenderContent={(target, content) => (
              <div
                className="th-hint__content"
                dangerouslySetInnerHTML={{
                  __html: String(content),
                }}
              />
            )}
            className="th-hint"
          />
          <UserContext.Provider value={{ user, setUser: this.setUser }}>
            <AppRouter
              history={history}
              errors={errors}
              user={user}
              onSignOut={this.onSignOut}
              onSignIn={this.onSignIn}
            />
          </UserContext.Provider>
        </React.StrictMode>
      </>
    );
  }
}

export default App;
